import React from 'react';
import { GoogleMap, withScriptjs, withGoogleMap } from "react-google-maps";

//CORE COMPONENTS
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';

//CUSTOM COMPONENTS
import { TopContainer } from '../../helpers/ComponentHelpers';

function Map() {
    return (
        <GoogleMap defaultZoom={10} defaultCenter={{ lat: 41.008240, lng: 28.978359 }} />
    )
}

const WrappedMap = withScriptjs(withGoogleMap(Map))


class ContactInfo extends React.Component {

    renderSectionUp() {
        return (
            <Container
                wrap={ContainerWrap.always}
                padding={sectionUpContainerPadding}
                gutter={ContainerGutter.dynamic0100}
            >
                <Text appearance={TextAppearance.headline0350} bold>
                    <Text bold>{'İletişim Bilgileri'} </Text>
                </Text>
            </Container>
        )
    }

    renderSectionLeft() {

        return (
            <Container stretchContent={true} padding={sectionLeftContainerPadding}>
                <div style={{ width: '100vw', height: '70vh' }}>
                    <WrappedMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyBZfIhEu6OW6AULX-U3N75KD4mftpZKu44`}
                        loadingElement={<div style={{ height: "100%", width: "100%" }} />}
                        containerElement={<div style={{ height: "100%", width: "100%" }} />}
                        mapElement={<div style={{ height: "100%", width: "100%" }} />}

                    />
                </div>
            </Container>


        )
    }

    renderSectionRight() {

        return (
            <Container padding={sectionRightContainerPadding}
            horizontalAlign={ContainerHorizontalAlignment.center}
            verticalAlign={ContainerVerticalAlignment.center}>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }} >
                    {renderSmallText('Adres', true)}<br/>
                    {renderSmallText('Maslak Mah. Ahi Evran Cad. Doğuş Center No: 4, İç Kapı No: 7 34398 Sarıyer/İSTANBUL', false)}
                </Container>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    {renderSmallText('Telefon', true)}<br/>
                    {renderSmallText('444 89 24', false)}
                </Container>
                <Container padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    {renderSmallText('E-Posta', true)}<br/>
                    {renderSmallText('info@vw.com.tr', false)}
                </Container>
            </Container>

        )
    }
   

    render() {
        return (
            <TopContainer>
                {this.renderSectionUp()}
                <Layout appearance={layoutAppearance}>
                    {this.renderSectionLeft()}
                    {this.renderSectionRight()}
                </Layout>
            </TopContainer>
        )
    }
}

const renderSmallText = (text, bold) => (
    <Container padding={{ bottom: bold ? ContainerPadding.static150 : ContainerPadding.dynamic0020 }}>
        <Text bold={bold} wordBreak appearance={TextAppearance.copy0150}>
            {text}<br/>
        </Text>
    </Container>
)

const sectionUpContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid007
    },
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0200
    }
}

const titleDescriptionContainerPadding = {
    left: {
        [Breakpoints.b560]: ContainerPadding.grid001,
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid001,
        [Breakpoints.b560]: ContainerPadding.grid008
    }
}

const layoutAppearance = {
    [Breakpoints.default]: [
        { name: 'a', columns: 24 },
        { name: 'b', columns: 24 }
    ],
    [Breakpoints.b960]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 10 },
        { name: 'b', columns: 10 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b1920]: [
        { name: '.', columns: 4 },
        { name: 'a', columns: 8 },
        { name: 'b', columns: 8 },
        { name: '.', columns: 4 }
    ]
}

const sectionLeftContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: null
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid001
    },
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0100,
        [Breakpoints.b960]: null
    }
}

const sectionRightContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: null
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid005,
        [Breakpoints.b960]: null
    }
}

export default ContactInfo;

